import { singletonFactory } from '@warehouse/shared/util';
import { BrokerService, BrokerServicesRepository } from '../core';
import availableServices from '../../../../src/assets/json-administration-profiles/availableServices.json';

export class BrokerServicesRepositoryJson implements BrokerServicesRepository {
	// availableServices.json is generated from services.json by scripts/extractServices.js, which
	// copies each field straight through — so a service that declares no inputType or
	// requiredPermissions loses those keys entirely to JSON.stringify. Fill them in here instead of
	// making them optional on BrokerService, so the permission check in TriggerServiceMenu stays
	// unconditional and every consumer gets a whole service.
	public getAvailableServicesConfig(): BrokerService[] {
		return availableServices.map((service) => ({
			...service,
			// Matches no NxObjectType, so a service with no declared input type is offered for nothing.
			inputType: service.inputType ?? '',
			requiredPermissions: service.requiredPermissions ?? [],
		}));
	}
}

export const brokerServicesRepositorySingleton = singletonFactory<BrokerServicesRepository>({
	factory: () => new BrokerServicesRepositoryJson(),
});
